module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[53]52.1330a35.woff2";